module.exports = __webpack_public_path__ + "static/media/id0-always_be_ready.7428dda3.jpg";